import '@/shared/styles/global.css'

// Circuit breaker for the sign-in redirect loop. Each failed auth round-trip
// (signinRedirect -> /callback -> back to AuthGuard still unauthenticated) bumps
// this counter; a successful sign-in clears it. Without a cap, a persistent
// failure (clock skew, revoked session, Authentik rejecting the scope/grant) would
// redirect to Authentik forever and lock the user out of any error UI.
export const AUTH_ATTEMPTS_KEY = 'authAttempts'
export const MAX_AUTH_ATTEMPTS = 3

export const getAuthAttempts = () => Number(sessionStorage.getItem(AUTH_ATTEMPTS_KEY) ?? '0')
export const bumpAuthAttempts = () => sessionStorage.setItem(AUTH_ATTEMPTS_KEY, String(getAuthAttempts() + 1))
export const clearAuthAttempts = () => sessionStorage.removeItem(AUTH_ATTEMPTS_KEY)
